import { style, } from 'styled-system';
var transformValueFromTheme = function (n, theme) {
    var val = theme[n] || n;
    return typeof val !== 'string' ? val + "px" : val;
};
var createStyleFn = function (variant) {
    return style(variant);
};
export var themeWidth = style({
    prop: 'themeWidth',
    cssProperty: 'width',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMaxWidth = style({
    prop: 'themeMaxWidth',
    cssProperty: 'maxWidth',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMinWidth = style({
    prop: 'themeMinWidth',
    cssProperty: 'minWidth',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeHeight = style({
    prop: 'themeHeight',
    cssProperty: 'height',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMaxHeight = style({
    prop: 'themeMaxHeight',
    cssProperty: 'maxHeight',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeMinHeight = style({
    prop: 'themeMinHeight',
    cssProperty: 'minHeight',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeTop = style({
    prop: 'themeTop',
    cssProperty: 'top',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeRight = style({
    prop: 'themeRight',
    cssProperty: 'right',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeBottom = style({
    prop: 'themeBottom',
    cssProperty: 'bottom',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var themeLeft = style({
    prop: 'themeLeft',
    cssProperty: 'left',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var columns = style({
    prop: 'columns',
    cssProperty: 'columns',
});
export var cursor = style({
    prop: 'cursor',
    cssProperty: 'cursor',
});
export var boxSizing = style({
    prop: 'boxSizing',
});
export var flexGrow = style({
    prop: 'flexGrow',
});
export var textDecoration = style({
    prop: 'textDecoration',
});
export var whiteSpace = createStyleFn({
    prop: 'whiteSpace',
});
export var textOverflow = createStyleFn({
    prop: 'textOverflow',
});
export var overflowY = createStyleFn({
    prop: 'overflowY',
});
export var overflowX = createStyleFn({
    prop: 'overflowX',
});
export var borderTopColor = style({
    prop: 'borderTopColor',
    key: 'colors',
});
export var borderBottomColor = style({
    prop: 'borderBottomColor',
    key: 'colors',
});
export var borderRightWidth = style({
    prop: 'borderRightWidth',
    key: 'space',
});
export var borderLeftWidth = style({
    prop: 'borderLeftWidth',
    key: 'space',
});
export var borderTopWidth = style({
    prop: 'borderTopWidth',
    key: 'space',
});
export var borderBottomWidth = style({
    prop: 'borderBottomWidth',
    key: 'space',
});
export var pointerEvents = style({
    prop: 'pointerEvents',
});
export var fill = createStyleFn({
    prop: 'fill',
    key: 'colors',
});
export var stroke = style({
    prop: 'stroke',
    key: 'colors',
});
export var borderRadiusTR = style({
    prop: 'borderRadiusTR',
    cssProperty: 'borderTopRightRadius',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var borderRadiusTL = style({
    prop: 'borderRadiusTL',
    cssProperty: 'borderTopLeftRadius',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var borderRadiusBR = style({
    prop: 'borderRadiusBR',
    cssProperty: 'borderBottomRightRadius',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var borderRadiusBL = style({
    prop: 'borderRadiusBL',
    cssProperty: 'borderBottomLeftRadius',
    key: 'space',
    transformValue: transformValueFromTheme,
});
export var translate3d = style({
    prop: 'translate3d',
    cssProperty: 'transform',
    transformValue: function (val) { return "translate3d(" + val + ")"; },
});
export var scale = style({
    prop: 'scale',
    cssProperty: 'transform',
    transformValue: function (val) { return "scale(" + val + ")"; },
});
export var rotate = style({
    prop: 'rotate',
    cssProperty: 'transform',
    transformValue: function (val) { return "rotate(" + val + "deg)"; },
});
export var transition = style({
    prop: 'transition',
    cssProperty: 'transition',
});
export var textTransform = style({
    prop: 'textTransform',
    cssProperty: 'textTransform',
});
export var lineClamp = style({
    prop: 'lineClamp',
    cssProperty: 'WebkitLineClamp',
});
export var listStyle = style({
    prop: 'listStyle',
});
